import Decimal from "decimal.js";

Decimal.set({
  precision: 28,
  rounding: Decimal.ROUND_HALF_UP,
});

export const decimal = (value: Decimal.Value = 0): Decimal =>
  new Decimal(value || 0);

export const nonNegative = (value: Decimal.Value = 0): Decimal =>
  Decimal.max(0, decimal(value));

export const minDecimal = (...values: Decimal.Value[]): Decimal =>
  Decimal.min(...values.map(decimal));

export const maxDecimal = (...values: Decimal.Value[]): Decimal =>
  Decimal.max(...values.map(decimal));

export const money = (value: Decimal.Value = 0): number =>
  decimal(value).toDecimalPlaces(2, Decimal.ROUND_HALF_UP).toNumber();

export const precise = (value: Decimal.Value = 0, places = 6): number =>
  decimal(value).toDecimalPlaces(places, Decimal.ROUND_HALF_UP).toNumber();
